// extracted by mini-css-extract-plugin
module.exports = {"alert":"index_alert__c_q5q","info":"index_info__xgXbR","danger":"index_danger__D6z8e"};